export enum Language {
  ENGLISH = 'english',
  SPANISH = 'spanish',
  ENGLISH_ABBR = 'en',
  SPANISH_ABBR = 'es',
  LOCAL_STORAGE_VAR = 'language',
  QUERY_PARAM = 'lang',
}
